import ConfiguredAppsConfig from './ConfiguredApps';
import CoreConfig from './Core';
import FunctionalAppsConfig from './FunctionalApps';
import RoleSpecificAppsConfig from './RoleSpecificApps';

export default [...ConfiguredAppsConfig, ...CoreConfig, ...FunctionalAppsConfig, ...RoleSpecificAppsConfig];
